var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 view-extras" },
    [
      _c("b-form-group", {
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _c("b", { staticClass: "w-100 mb-2" }, [
                  _vm._v("Choose your flavours:"),
                ]),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-form-checkbox",
                  {
                    attrs: {
                      indeterminate: _vm.indeterminate,
                      "aria-describedby": "flavours",
                      "aria-controls": "flavours",
                    },
                    on: { change: _vm.toggleAll },
                    model: {
                      value: _vm.allSelected,
                      callback: function ($$v) {
                        _vm.allSelected = $$v
                      },
                      expression: "allSelected",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.allSelected ? "Un-select All" : "Select All"
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "default",
            fn: function (ref) {
              var ariaDescribedby = ref.ariaDescribedby
              return [
                _c("b-form-checkbox-group", {
                  staticClass: "ml-4 checkbox-group",
                  attrs: {
                    id: "flavors",
                    options: _vm.flavours,
                    "aria-describedby": ariaDescribedby,
                    name: "flavors",
                    "aria-label": "Individual flavours",
                    stacked: "",
                  },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n        Selected: "),
        _c("strong", [_vm._v(_vm._s(_vm.selected))]),
        _c("br"),
        _vm._v("\n        All Selected: "),
        _c("strong", [_vm._v(_vm._s(_vm.allSelected))]),
        _c("br"),
        _vm._v("\n        Indeterminate: "),
        _c("strong", [_vm._v(_vm._s(_vm.indeterminate))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }